
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { LayoutService } from 'src/app/layout/layout.service';

@Component({
  selector: 'app-servicenear-my-other-devices',
  templateUrl: './servicenear-my-other-devices.component.html',
  styleUrls: ['./servicenear-my-other-devices.component.scss']
})
export class ServicenearMyOtherDevicesComponent implements OnInit, OnDestroy {

  public devices: any[] = [];
  public isLoading: boolean = true;

  // Toast notification
  public showToast: boolean = false;
  public notificationMsg: string = '';
  public isSuccess: boolean = true;

  // Revoke confirmation popup
  public showRevokeConfirm: boolean = false;
  public pendingRevokeDevice: any = null;

  private subscription = new Subscription();

  constructor(
    private adminService: AdminService,
    private layoutService: LayoutService,
  ) { }

  public ngOnInit(): void {
    this.populateToolbarData();
    this.getDeviceLogin();
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private populateToolbarData(): void {
    this.layoutService.setToolbar({ title: 'My Other Devices' });
    this.layoutService.setNavbarButtons([]);
  }

  public getDeviceLogin(): void {
    this.isLoading = true;
    this.subscription.add(
      this.adminService.userDevice().subscribe(
        (res: any) => {
          if (res.ResponseData) {
            this.devices = res.ResponseData.map((device: any) => ({
            id: device.Id,
            name: `${device.Browser} on ${device.OperatingSystem}`,
            type: device.OperatingSystem,
            createdDate: device.Created,
            isActive: device.IsActive,
            ipAddress: device.CreatedByIp,
            }));
          } else {
            this.devices = [];
          }
          this.isLoading = false;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify(false, 'Failed to load devices. Please try again.');
        }
      )
    );
  }

  public confirmRevoke(device: any): void {
    this.pendingRevokeDevice = device;
    this.showRevokeConfirm = true;
  }

  public cancelRevoke(): void {
    this.pendingRevokeDevice = null;
    this.showRevokeConfirm = false;
  }

  public revokeAccess(device: any): void {
    this.isLoading = true;
    this.showRevokeConfirm = false;
    this.subscription.add(
      this.adminService.revokeToken(device.id).subscribe((res: any) => {
        this.notify(true, 'Device access revoked successfully.');
        this.getDeviceLogin();
        this.isLoading = false;
      },
        (error: HttpErrorResponse) => {
          console.error('Error revoking token:', error);
          this.isLoading = false;
          this.notify(false, 'Failed to revoke access. Please try again.');
        },
      ));
  }

  private notify(success: boolean, msg: string): void {
    this.isSuccess = success;
    this.notificationMsg = msg;
    this.showToast = true;
    setTimeout(() => { this.showToast = false; }, 3000);
  }
}
